import { motion } from "framer-motion";

const chapters = [
  {
    no: "01",
    title: "Drink with intent.",
    body: "The dram is not entertainment. It is punctuation. A pause the day has earned.",
  },
  {
    no: "02",
    title: "Prefer the well-made to the loud.",
    body: "Objects, garments, spirits — all should carry the fingerprints of the maker, and none of the noise.",
  },
  {
    no: "03",
    title: "Sit inside the evening.",
    body: "Music low. Lamps warm. No screens. The company of good friends or none.",
  },
  {
    no: "04",
    title: "Know what is in your glass.",
    body: "Region, cask, hand. A bottle without a story is a stranger at your table.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative py-28 md:py-40"
    >
      <div className="max-w-[1600px] mx-auto px-6 sm:px-10 grid grid-cols-12 gap-6">
        <div className="col-span-12 lg:col-span-3 mb-14 lg:mb-0">
          <div className="sticky top-32">
            <div className="eyebrow mb-4">The House Rules</div>
            <h2 className="font-display text-4xl lg:text-5xl leading-[1.02] tracking-tight text-bone">
              A quiet <em className="italic" style={{ color: "var(--amber)" }}>code</em>, kept between those who know.
            </h2>
          </div>
        </div>

        <div className="col-span-12 lg:col-span-9 lg:pl-14">
          <ul className="flex flex-col">
            {chapters.map((c, i) => (
              <motion.li
                key={c.no}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-10%" }}
                transition={{ duration: 0.85, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
                className="grid grid-cols-12 gap-6 py-10 border-t"
                style={{ borderColor: "var(--hairline)" }}
                data-testid={`manifesto-chapter-${c.no}`}
              >
                <div className="col-span-3 md:col-span-2">
                  <div className="chapter-numeral text-6xl md:text-7xl">{c.no}</div>
                </div>
                <div className="col-span-9 md:col-span-10">
                  <h3 className="font-display italic text-3xl md:text-4xl leading-tight text-bone mb-3">
                    {c.title}
                  </h3>
                  <p className="font-body text-lg text-bone-dim max-w-2xl">{c.body}</p>
                </div>
              </motion.li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
